import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="policy-container">
      <h1>🔒 Privacy Policy</h1>
      <p><strong>Effective Date:</strong> 25 June 2025</p>
      <p>Your privacy is important to us. This Privacy Policy explains how <strong>GEAR ON</strong> collects, uses, and protects your personal information when you use our mobile application.</p>

      <h3>1. Information We Collect</h3>
      <ul>
        <li><strong>Account Information:</strong> We may collect your Google ID or other login credentials to enable you to sign up and use the app.</li>
        <li><strong>Usage Data:</strong> We may record app usage data, preferences, and interactions to improve your experience.</li>
        <li><strong>Device Information:</strong> Information about your device, OS version, and app version may be collected for technical support purposes.</li>
      </ul>

      <h3>2. How We Use Information</h3>
      <ul>
        <li>✅ Operate and maintain the app</li>
        <li>✅ Provide and improve the features and services</li>
        <li>✅ Respond to your queries and support requests</li>
      </ul>
      <p><strong>We do not sell or share your personal data with third parties under any circumstances.</strong></p>

      <h3>3. Data Security</h3>
      <p>We take reasonable measures to protect your data from unauthorized access, disclosure, or loss. However, please note that no internet transmission is 100% secure.</p>

      <h3>4. Third-Party Services</h3>
      <p>Our app may use third-party services (e.g., login with Google). Please note that these services have their own privacy policies, which we encourage you to review.</p>

      <h3>5. Motor Vehicle Act Compliance</h3>
      <p>Our app allows booking of bikes, scooters, and cars in compliance with the Motor Vehicle Act, 1988. Users must possess a valid driving license and follow applicable traffic and safety regulations. GEAR ON is not responsible for any traffic violations, accidents, theft, or other liabilities during the use of rented vehicles.</p>

      <h3>6. No Liability</h3>
      <p>GEAR ON acts as a platform to connect users with vehicle vendors. We do not guarantee the condition, safety, or availability of any vehicle. Any damages, accidents, or legal issues arising from vehicle usage are the sole responsibility of the user and vendor.</p>

      <h3>7. Changes to This Privacy Policy</h3>
      <p>We may update this Privacy Policy periodically. We encourage you to review this page regularly to stay informed about our privacy practices.</p>

      <h3>8. Contact Us</h3>
      <p>If you have any questions about this Privacy Policy, please contact us at: <a href="mailto:gearon2426@gmail.com">gearon2426@gmail.com</a></p>

      <h3>Your Consent</h3>
      <p>By using the Application, you are consenting to the processing of your information as set forth in this Privacy Policy now and as amended by us.</p>
    </div>
  );
};

export default PrivacyPolicy;
